<template>
  <div v-loading="loading" style="height: 250px;width: 100%;" />
</template>

<script>
import { homeFutureApi } from '@/api/ei/eiApi'
import { debounce } from '@/utils/common'

export default {
  name: 'IncomeLine',

  data() {
    return {
      loading: false,
      stats: {},
      chart: null,
      chartOption: {
        title: {
          text: '未来6个月预估'
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 10,
          // top: 10,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter: '{b} 预估收入: ￥{c}'
        },
        xAxis: {
          data: [],
          boundaryGap: true
        },
        yAxis: [{
          type: 'value'
        }],
        series: [
          {
            name: '预估收入',
            type: 'line',
            smooth: false,
            itemStyle: {
              color: '#07c160'
            },
            data: []
          }
        ]
      }
    }
  },

  mounted() {
    this.initChart()
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },

  created: function() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      homeFutureApi().then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.stats = Object.assign({}, res.data.future_income)
          this.setChart()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    setChart() {
      this.chartOption.xAxis.data = this.stats.date
      this.chartOption.series[0].data = this.stats.due_in
      this.chart.setOption(this.chartOption)
    },

    initChart() {
      this.chart = this.$echarts.init(this.$el, 'teenager')
      this.chart.setOption(this.chartOption)
    }
  }
}
</script>
